import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Eye, LucideIcon } from "lucide-react";

interface StatsCardProps {
  title: string;
  value: string | number;
  description?: string;
  icon: LucideIcon;
  onClick?: () => void;
}

export const StatsCard = ({
  title,
  value,
  description,
  icon: Icon,
  onClick,
}: StatsCardProps) => {
  return (
    <Card className="relative overflow-hidden" onClick={onClick}>
      {onClick && (
        <div className="absolute inset-0 w-full h-full cursor-pointer" />
      )}
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <div className="flex items-center gap-2">
          {onClick && (
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 relative z-10"
              onClick={(e) => {
                e.stopPropagation();
                onClick();
              }}
            >
              <Eye className="h-4 w-4" />
            </Button>
          )}
          <Icon className="h-4 w-4 text-muted-foreground" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold">{value}</div>
        {description && (
          <p className="text-base text-clubbers-red flex items-center gap-2">
            {description}
            <Eye className="h-4 w-4" />
          </p>
        )}
      </CardContent>
    </Card>
  );
};